import type { ThemeConfig } from '../types'

export const currentTheme: ThemeConfig = {
  meta: {
    name: 'TROIA Current',
    version: '1.0.0',
  },

  colors: {
    primary: '#8b5cf6',
    primaryHover: '#7c3aed',
    primaryLight: '#f3e8ff',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',

    background: {
      page: { type: 'solid', value: '#f8fafc' },
      card: '#ffffff',
      sidebar: '#ffffff',
      header: '#ffffff',
      input: '#ffffff',
      elevated: '#ffffff',
    },

    text: {
      primary: '#1e293b',
      secondary: '#334155',
      muted: '#6b7280',
      inverse: '#ffffff',
    },

    border: {
      default: 'rgba(0, 0, 0, 0.06)',
      strong: 'rgba(0, 0, 0, 0.10)',
      input: 'rgba(0, 0, 0, 0.10)',
      focus: 'rgba(139, 92, 246, 0.25)',
    },

    separator: 'rgba(0, 0, 0, 0.06)',
  },

  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
    fontFamilyMono: "'SF Mono', 'JetBrains Mono', 'Fira Code', monospace",
    sizes: {
      xs: '11px',
      sm: '12px',
      base: '13px',
      md: '14px',
      lg: '16px',
      xl: '20px',
      '2xl': '24px',
    },
    weights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    letterSpacing: {
      tight: '-0.02em',
      normal: '-0.011em',
      wide: '0.02em',
    },
  },

  radius: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },

  borders: {
    width: '1px',
    style: 'solid',
  },

  shadows: {
    sm: 'none',
    md: 'none',
    lg: 'none',
    xl: 'none',
    dropdown: '0 4px 24px rgba(0,0,0,0.12), 0 0 1px rgba(0,0,0,0.08)',
  },

  blur: {
    header: 'none',
    sidebar: 'none',
    elevated: 'none',
  },

  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },

  spacing: {
    unit: 4,
    page: { x: 'clamp(1rem, 3vw, 2rem)', y: '2rem' },
    card: { x: '1.25rem', y: '1rem' },
    section: '1.5rem',
  },

  icons: {
    pack: 'fi',
    // Rede de segurança: qualquer nome ausente do pack primário resolve pelo
    // lucide (cobertura 100% do type IconName) antes de cair no alert-circle.
    fallbackPack: 'lu',
    strokeWidth: 2,
  },

  dark: {
    colors: {
      primary: '#a855f7',
      primaryHover: '#6d28d9',
      primaryLight: 'rgba(168, 85, 247, 0.1)',
      success: '#34d399',
      warning: '#fbbf24',
      error: '#f87171',
      info: '#60a5fa',

      background: {
        page: {
          type: 'image-overlay' as const,
          value: 'https://s3.sa-east-1.amazonaws.com/whatsapp.troia/avatars/1772990808212-2fbnk.png',
          overlay: 'rgba(0, 0, 0, 0.5)',
          attachment: 'fixed' as const,
          // Tom petróleo médio da imagem+véu — base opaca dos overlays mobile
          solidColor: '#0e3a49',
        },
        card: 'rgba(0, 0, 0, 0.1)',
        sidebar: 'rgba(0, 0, 0, 0.1)',
        header: 'rgba(0, 0, 0, 0.1)',
        input: 'rgba(0, 0, 0, 0.1)',
        elevated: 'rgba(255, 255, 255, 0.1)',
      },

      text: {
        primary: '#e5e7eb',
        secondary: '#d1d5db',
        muted: '#9ca3af',
        inverse: '#1e293b',
      },

      border: {
        default: 'rgba(255, 255, 255, 0.05)',
        strong: 'rgba(255, 255, 255, 0.1)',
        input: 'rgba(255, 255, 255, 0.1)',
        focus: 'rgba(109, 40, 217, 0.5)',
      },

      separator: 'rgba(255, 255, 255, 0.06)',
    },

    shadows: {
      sm: 'none',
      md: 'none',
      lg: '0 8px 24px rgba(0,0,0,0.5)',
      xl: '0 16px 48px rgba(0,0,0,0.6)',
      dropdown: '0 4px 24px rgba(0,0,0,0.4)',
    },
  },
}
